module.exports = __webpack_public_path__ + "static/media/registrationSurvey.4b47255a.svg";